<template>
  <div
    class="modal fade modal-forgot-password"
    id="ForgotPasswordModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="ForgotPasswordModal"
    aria-hidden="true"
  >
    <div class="container">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="row align-items-stretch no-gutters">
            <div class="col-12 col-lg-6">
              <div class="modal-login__col"></div>
            </div>
            <div class="col-12 col-lg-6 d-flex flex-column">
              <ValidationObserver ref="form" v-slot="{ invalid }">
                <div class="modal-header">
                  <h4>{{ $t("forgotPassword") }}?</h4>
                  <a
                    href="#"
                    class="icon icon-cross"
                    data-dismiss="modal"
                    aria-label="Close"
                    >{{ $t("close") }}</a
                  >
                </div>
                <div class="modal-body">
                  <div class="mb-2">
                    {{ $t("forgotPasswordLabel") }}
                  </div>
                  <form @submit.prevent.stop>
                    <div class="form-group">
                      <validation-provider
                        name="email"
                        rules="required|email"
                        ref="myinput"
                        v-slot="{ errors }"
                      >
                        <input
                          type="text"
                          class="form-control"
                          :placeholder="$t('form.email')"
                          v-model="email"
                          :class="{ 'is-invalid': errors.length }"
                          id="rest-password-email"
                        />
                      </validation-provider>
                    </div>
                  </form>
                </div>
                <div class="modal-footer">
                  <button
                    @click="store"
                    class="btn btn-primary w-100"
                    :disabled="invalid"
                  >
                    {{ $t("buttons.send") }}
                  </button>
                  <div
                    v-if="monitor.visible"
                    class="px-1 text-center"
                    :class="monitor.type"
                  >
                    {{ monitor.message }}
                  </div>
                </div>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
export default {
  name: "ForgotPasswordModal",
  data() {
    return {
      email: null,
      monitor: {
        visible: false,
        message: "",
        type: "text-warning",
      },
    };
  },
  computed: {
    ...mapFields([]),
  },
  methods: {
    store() {
      let data = {};
      data.email = this.email;
      let appUrl = document.head.querySelector('meta[name="app-url"]').content;
      data.locale = document.head.querySelector(
        'meta[name="app-locale"]'
      ).content;
      if (data.locale != "fr") {
        data.url = appUrl + "/" + data.locale + "/forgot-password";
      } else {
        data.url = appUrl + "/forgot-password";
      }
      this.$store
        .dispatch("forgotPassword", data)
        .then((response) => {
          if (response.status === 200) {
            this.monitor.type = "text-success";
            this.monitor.visible = true;
            this.monitor.message = this.$t("checkEmailboxMessage");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        })
        .catch((error) => {
          this.monitor.type = "text-warning";
          this.monitor.visible = true;
          if (error.response) {
            if (error.response.status == 421) {
              this.monitor.type = "text-danger";
              this.monitor.message = this.$t("errors.invalidEmail");
              this.email = null;
            } else {
              this.monitor.message = this.$t("errors.serverError");
              setTimeout(() => {
                this.monitorHide();
              }, 1500);
            }
          }
        });
    },
    monitorHide() {
      this.monitor.type = "";
      this.monitor.message = "";
      this.monitor.visible = false;
    },
  },
};
</script>

<style scoped></style>
